<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")
</template>

<script>
import receiptMixin from '@js/mixins/receipt';
import Feature from '@js/plugins/feature';
import { mapState } from 'vuex';

export default {
    mixins: [receiptMixin],

    data: function() {
        var that = this;

        let columns = [
            'code',
            'product_name',
            'category_name',
            'tags',
            'total_quantity',
            'receipt_number',
            'staff_name',
            'total_net_sales',
            'creation_date',
        ];

        if (!Feature.hasFeature('fuel')) {
            columns.push('variant_name');
        }

        return {
            tableName: 'STAFF_SALES',
            columns: columns,
            options: {
                texts: {
                    title: 'Product Sales by Staff',
                    description: 'Shows product sales by staff',
                },
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                useReportFilter: true,
                headings: {
                    code: 'Barcode',
                    product_name: 'Product Name',
                    variant_name: 'Variant',
                    category_name: this.trans('category.title'),
                    tags: this.trans('tag.title'),
                    receipt_number: 'Receipt No.',
                    total_quantity: 'Quantity (#)',
                    staff_name: 'Staff',
                    total_net_sales: 'Net Sales (RM)',
                },
                columnsClasses: {
                    total_quantity: 'text-right',
                    total_net_sales: 'text-right',
                },
                templates: {
                    receipt_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },
                    creation_date: (h, row) => {
                        return this.receiptDateFormat(row.creation_date);
                    },
                },
                orderBy: {
                    ascending: false,
                    column: 'creation_date',
                },
                pdf_url: Laroute.route(
                    'franchise.report.non_fuel.item.staff.export',
                    {
                        type: 'PDF',
                    },
                ),
                csv_url: Laroute.route(
                    'franchise.report.non_fuel.item.staff.export',
                    {
                        type: 'CSV',
                    },
                ),
                xls_url: Laroute.route(
                    'franchise.report.non_fuel.item.staff.export',
                    {
                        type: 'XLSX',
                    },
                ),
                requestFunction: function(request) {
                    return axios
                        .post(this.url, request)
                        .catch(e => this.dispatch('error', e));
                },
                export_post: true,
                export_filename: 'Product Sales by Staff',
            },
        };
    },
    computed: {
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route('franchise.report.non_fuel.item.staff.index');
        },
    },
    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/vuetable-staff-sales.vue